module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand2_en.7214e376c3bd5de18e98808224ad8950.png";